// This file auto-imports all controllers
import { application } from "./application.js"

import TooltipController from "./tooltip_controller.js"
import CopyLinkController from "./copy_link_controller.js"
import ClickableRowController from "./clickable_row_controller.js"
import FieldListController from "./field_list_controller.js"
import LegalHeadingsController from "./legal_headings_controller.js"
import MarkdownEditorController from "./markdown_editor_controller.js"
import FlatpickrController from "./flatpickr_controller.js"
import ReplaceMeController from "./replace_me_controller.js"
import DiscountKindController from "./discount_kind_controller.js"
import AvailabilityCheckController from "./availability_check_controller.js"
import SlugFromUrlController from "./slug_from_url_controller.js"
import BranchSearchController from "./branch_search_controller.js"
import SplitviewController from "./splitview_controller.js"
import FileUploadController from "./file_upload_controller.js"

application.register("tooltip", TooltipController)
application.register("copy-link", CopyLinkController)
application.register("clickable-row", ClickableRowController)
application.register("field-list", FieldListController)
application.register("legal-headings", LegalHeadingsController)
application.register("markdown-editor", MarkdownEditorController)
application.register("flatpickr", FlatpickrController)
application.register("replace-me", ReplaceMeController)
application.register("discount-kind", DiscountKindController)
application.register("availability-check", AvailabilityCheckController)
application.register("slug-from-url", SlugFromUrlController)
application.register("branch-search", BranchSearchController)
application.register("splitview", SplitviewController)
application.register("file-upload", FileUploadController)


